import { Button } from 'palette/Button';
import { useTranslation } from '@common/Hooks/useTranslation';
import './styles/BurgerNavButton.scss';

function BurgerNavButton({ setIsNavOpen }) {
    const translate = useTranslation();

    const handleClick = () => {
        setIsNavOpen(true);
    };

    return (
        <Button
            isTransparent
            ariaLabel={translate('main.header.navigation')}
            iconName="palette_hamburger"
            theme="secondary"
            onClick={handleClick}
        />
    );
}

export default BurgerNavButton;
